import { useState, useCallback } from "react";
import axios from "axios";
import useWalletConnect from "./useWalletConnect";
import { getTasaDeCambio } from "../../utils/exchangeRate";

function useEnviarConfirmacionServidor({ cantidadTbtc, direccionBitcoin, address, selectedTokenSymbol }) {
  const [error, setError] = useState(null);
  const [estado, setEstado] = useState("");
  const [depositoConfirmado, setDepositoConfirmado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [txid, setTxid] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;
  const API_USERNAME = process.env.REACT_APP_API_USERNAME;
  const API_PASSWORD = process.env.REACT_APP_API_PASSWORD;
  const SATOSHI_CONVERSION_FACTOR = 100000000;
  const { network } = useWalletConnect();

  const enviarConfirmacionServidor = useCallback(
    async (transaccion) => {
      setError(null);
      setEstado("");
      setDepositoConfirmado(false);
      setLoading(true);

      setTxid("");
      const exchangeRate = getTasaDeCambio(network, selectedTokenSymbol);
      try {
        const amountToSend = cantidadTbtc*SATOSHI_CONVERSION_FACTOR*exchangeRate;
        // const amountToSend = Math.floor(cantidadTbtc*SATOSHI_CONVERSION_FACTOR*exchangeRate);
        // const amountToSend = parseInt(cantidadTbtc*SATOSHI_CONVERSION_FACTOR*exchangeRate);

        const dataToSend = {
          amountToSend: amountToSend,
          toAddress: direccionBitcoin,
          fromAddress: address,
        };
        console.log("Datos enviados al servidor:", dataToSend);

        const response = await axios.post(
          API_URL,
          dataToSend,
          {
            auth: {
              username: API_USERNAME,
              password: API_PASSWORD,
            },
          }
        );

        if (response.status === 200) {
          const { message, txid } = response.data;
          setEstado(message);
          setTxid(txid);
          setDepositoConfirmado(true);
        } else {
          setError(
            response.data && response.data.error
              ? `Error al confirmar el depósito: ${response.data.error}`
              : "Error desconocido al confirmar el depósito."
          );
        }
      } catch (err) {
        setError(
          err.response && err.response.data && err.response.data.error
            ? `Error al enviar confirmación al servidor: ${err.response.data.error}`
            : "Error al enviar confirmación al servidor. Revisa la consola para más detalles."
        );
        console.error(err);
      } finally {
        setLoading(false);
      }
    },
    [cantidadTbtc, direccionBitcoin, address, selectedTokenSymbol, network, API_PASSWORD, API_URL, API_USERNAME]
  );

  return { enviarConfirmacionServidor, error, estado, depositoConfirmado, loading, txid };
}

export default useEnviarConfirmacionServidor;
